// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"downscale"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10 3H3V9M21 14V21H15M3 15V13H5M9 13H11V15M11 19V21H9M3 19V21H5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13.9443 5.08584L13.9725 10.0075L18.8941 10.0356M14.5048 9.47514L19.9858 3.99414","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DownscaleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'downscale',
    ref,
    icon: element,
  },
));

DownscaleIcon.displayName = 'DownscaleIcon';

export default DownscaleIcon;
